import React from 'react';
import { connect } from 'react-redux';
import { hot } from 'react-hot-loader';
import Select from '../../Elements/Select/Select';
import countries from '../../Selection/countries';
import { changeStockistCountry, changeStockistState, changeStockistType } from '../../../actions/environment';
import { offset } from '../../../utils/dom';
import { translate } from '../../../utils/locale';
import { addLinks } from '../../../utils/react-helpers';
import { urlify } from '../../../utils/string';
import s from './Stockists.scss';

const Stockists = ({ setup, content, stockistCountry, stockistState, stockistType, ...props }) => {
	if (!content) return null;
	const countryMap = Object.keys(countries).reduce((acc, c) => ({ ...acc, [countries[c].code]: c }), {});
	const countryKeys = content.countries ? content.countries.reduce((acc, c) => ({ ...acc, [c.country]: { key: c.key, country: (countryMap[c.country] || c.country), stockists: [...c.stockists, ...(acc?.[c.country]?.stockists || [])] } }), {}) : {};
	const countryOptions = [{ key: '', value: translate(setup, 'allCountries') }, ...Object.keys(countryKeys).map((c) => ({ key: c, value: countryKeys[c].country }), [])];

	const stockistStateKeys = Object.keys(countryKeys)
		.filter((c) => stockistCountry === '' || stockistCountry === c)
		.reduce((acc, c) => ({
			...acc,
			...countryKeys[c].stockists
				.filter((stockist) => (stockistType === '' || stockistType === urlify(stockist.type))) // Filter by type if type is set
				.reduce((acc2, stockist) => ({ ...acc2, [urlify(stockist.state)]: stockist.state }), {}),
		}), {});
	const stockistStateOptions = [{ key: '', value: translate(setup, 'allStates') }, ...Object.keys(stockistStateKeys)
		.filter((a) => !!a)
		.sort((a, b) => {
			if (a === 'online') a = 'zzzzzz';
			if (b === 'online') b = 'zzzzzz';
			return a.localeCompare(b);
		})
		.map((t) => ({ key: t, value: stockistStateKeys[t] }), [])];

	const stockistTypeKeys = Object.keys(countryKeys)
		.filter((c) => stockistCountry === '' || stockistCountry === c)
		.reduce((acc, c) => ({
			...acc,
			...countryKeys[c].stockists
				.filter((stockist) => (stockistState === '' || stockistState === urlify(stockist.state))) // Filter by state if state is set
				.reduce((acc2, stockist) => ({ ...acc2, [urlify(stockist.type)]: stockist.type }), {}),
		}), {});
	const stockistTypeOptions = [{ key: '', value: translate(setup, 'allTypes') }, ...Object.keys(stockistTypeKeys).filter((a) => !!a).sort((a, b) => a.localeCompare(b)).map((t) => ({ key: t, value: stockistTypeKeys[t] }), [])];

	const changeCountryHandler = (id, value) => {
		props.changeStockistType('');
		props.changeStockistCountry(value);
		props.changeStockistState('');
		window.scrollTo(0, offset(document.getElementById('stockist-results')).top - 50);
	};

	const changeStateHandler = (id, value) => {
		props.changeStockistState(value);
		window.scrollTo(0, offset(document.getElementById('stockist-results')).top - 50);
	};

	const changeTypeHandler = (id, value) => {
		props.changeStockistType(value);
		window.scrollTo(0, offset(document.getElementById('stockist-results')).top - 50);
	};

	return (
		<div id="stockist-results" className={s.stockists}>
			<div className={s.stockists_select}>
				<Select variantClasses={['select__stockists']} id="stockistCountry" options={countryOptions} selected={stockistCountry} inputChange={changeCountryHandler} />
				{
					stockistStateOptions.length > 2 && (
						<Select variantClasses={['select__stockists']} id="stockistState" options={stockistStateOptions} selected={stockistState} inputChange={changeStateHandler} />
					)
				}
				{
					stockistTypeOptions.length > 1 && (
						<Select variantClasses={['select__stockists']} id="stockistType" options={stockistTypeOptions} selected={stockistType} inputChange={changeTypeHandler} />
					)
				}
			</div>
			<div className={s.stockists_results}>
				{
					Object.keys(countryKeys).map((country) => {
						const c = countryKeys[country];
						if (country !== stockistCountry && stockistCountry !== '') return null;
						const groupedStockists = c.stockists
							.filter((stockist) => (
								(urlify(stockist.type) === stockistType)
								&& (stockistState === '' || urlify(stockist.state) === stockistState)
							))
							.reduce((acc, stockist) => {
								const state = stockist.state || 'general';
								if (acc[state]) {
									acc[state][acc[state].length] = stockist;
									return acc;
								}
								return { ...acc, [state]: [stockist] };
							}, {});

						const selectedStockists = Object.keys(groupedStockists).map((state) => (
							<div className={s.stockists_country_state}>
								{ state !== 'general' && <h4 className={s.stockists_country_state_title}>{ state }</h4> }
								<div className={s.stockists_country_state_items}>
									{
										groupedStockists[state].map((stockist) => (
											<div key={stockist.key} className={s.stockists_country_state_item}>
												<h6 className={s.stockists_country_state_item_title}>{ stockist.type }</h6>
												<p className={s.stockists_country_state_item_info}>{ addLinks(translate(setup, stockist.info)) }</p>
											</div>
										))
									}
								</div>
							</div>
						));

						return (
							<div key={c.key} className={s.stockists_country}>
								<h3 className={s.stockists_country_title}>{ c.country }</h3>
								<div className={s.stockists_country_states}>
									{ selectedStockists.length > 0 && selectedStockists }
									{
										selectedStockists.length === 0 && (
											<div className={s.stockists_country_states_chooseType}>
												<span>{translate(setup, 'chooseContactType')}</span>
											</div>
										)
									}
								</div>
							</div>
						);
					})
				}
			</div>
		</div>
	);
};


const mapState = ({ environment }, props) => ({
	...props,
	stockistCountry: environment.stockistCountry,
	stockistState: environment.stockistState,
	stockistType: environment.stockistType,
});

export default hot(module)(connect(mapState, { changeStockistCountry, changeStockistState, changeStockistType })(Stockists));
